import React from 'react';
import PropTypes from 'prop-types';

import useViewport from './useViewport';

const ViewportChecker = ({ range, children }) => {
  const { width } = useViewport();

  if (!range || (Array.isArray(range) && range.length === 0)) return false;

  return (
    <>
      {range.map(curr => width >= curr.min && width <= curr.max && (
        children
      )) }
    </>
  );
};

ViewportChecker.propTypes = {
  range: PropTypes.arrayOf(
    PropTypes.shape({
      min: PropTypes.number.isRequired,
      max: PropTypes.number.isRequired,
    }),
  ).isRequired,
  children: PropTypes.node.isRequired,
};

export default ViewportChecker;
